import { render, staticRenderFns } from "./IdentityVerify.vue?vue&type=template&id=7ea184ef&scoped=true&"
import script from "./IdentityVerify.vue?vue&type=script&lang=js&"
export * from "./IdentityVerify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea184ef",
  null
  
)

export default component.exports